// Generated by scripts/generate-public-surface.ts. Do not edit.
export { default as tn } from "./tn";
